import { render, staticRenderFns } from "./index_template.vue?vue&type=template&id=eb0f3138&scoped=true"
import script from "./index_template.vue?vue&type=script&lang=js"
export * from "./index_template.vue?vue&type=script&lang=js"
import style0 from "./index_template.vue?vue&type=style&index=0&id=eb0f3138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0f3138",
  null
  
)

/* custom blocks */
import block0 from "./index_template.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports